import ABCyaLib from "@abcya/abcya_lib";

export default function setupGameConfig(variantId, locale) {
  const config = {
    round3InstructionTextFontSize: 22,
    acceptedLetters: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  };
  switch (variantId) {
  }
  switch(locale) {
    case ABCyaLib.Environment.LOCALES.esUS: 
      config.round3InstructionTextFontSize = 20;
      config.acceptedLetters += 'ÑÁÉÍÓÚÜñáéíóúü'
  }
  return config;
}